import { LayoutCategory } from '../components/Layout/interface';
import request, { Options } from '../utils/requests/request';
// Contains claude-generated edits.

export interface CapiSelfIntroductionRequest {
  appCode: string;
  source: string;
  layoutCategory?: LayoutCategory;
}

export interface CapiSelfIntroduction {
  logo?: string;
  app: {
    introduction: string;
    capiLoanDefaultMsg?: string;
    capiLoanNoOperationMsg?: string;
    openingRemarksMsg?: string;
    voiceUrl?: string;
    avatar?: string;
  };
  fileTypeList?: string[]; // e.g. ['doc','docx','pdf','text']
  isMuteFlag?: 'Y' | 'N';
  isShowCapMsg?: 'Y' | 'N';
  isShowDisclaimer?: 'Y' | 'N';
  isShowThinking?: 'Y' | 'N';
  isShowVoiceButton?: 'Y' | 'N';
}

/**
 * Capi 自我介绍接口
 * POST /ai/capi/self-introduction
 */
export const capiSelfIntroduction = (params: CapiSelfIntroductionRequest, options?: Options) =>
  request.post<CapiSelfIntroduction>('/ai/capi/self-introduction', params, options);

// byClaude-start
/**
 * @description 检查推荐问题白名单，白名单用户展示新版 Capi gif
 * @author byClaude
 * NOTE: 接口真实返回结构待确认后调整泛型类型
 */
export const checkRecommendWhitelist = () =>
  request.post<boolean>('/credit/recommend-question/check-whitelist');
// byClaude-end
